import { useMemo } from "react";
import useQueueStore from "../stores/queue-store";
import useGetQueueConfig from "../apis/tryst/get-queue-config";
import { Appointment } from "@elixir/types";

const useGetViewShowToken = () => {
  const rightPanelQueueType = useQueueStore(
    (state) => state.rightPanelQueueType
  );
  const { data: queueConfig } = useGetQueueConfig();
  const { workflow_views } = queueConfig?.data || {};
  const showToken = useMemo(() => {
    const currentView = workflow_views?.find(
      (view) => view.viewId === rightPanelQueueType
    );
    return currentView?.showToken || false;
  }, [workflow_views, rightPanelQueueType]);

  return showToken;
};
export default useGetViewShowToken;
